import { IconWrapper } from '../runtime';
export default IconWrapper('dark-mode', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M14.25 9.08508C13.7173 12.0222 11.1444 14.2498 8.05057 14.2498C4.57086 14.2498 1.75 11.4319 1.75 7.9558C1.75 4.83899 4.01793 2.25132 6.99521 1.74976C6.70045 3.46022 6.62272 5.93813 8.05057 7.50624C9.32821 8.9094 12.551 9.30461 14.25 9.08508Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});